
import {currentMesh,currentPillarMesh,makeDataForModel} from './initThree'

// 源文件生成器，产出一个blob
function SourceExporter() {
    this.canvas = document.createElement("canvas");
    this.context = this.canvas.getContext("2d");
}

SourceExporter.RedChannelRatio = 0.299 / 255;
SourceExporter.GreenChannelRatio = 0.587 / 255;
SourceExporter.BlueChannelRatio = 0.114 / 255;

// 生成blob
SourceExporter.prototype.makeBlob = function (draw) {
    // 提升精度
    // let oldImageWidth = draw.imageWidth; // 保存宽度
    // draw.imageWidth = 1200;
    let { w, h, padding, cubeSize, data } = makeDataForModel(draw);
    // draw.imageWidth = oldImageWidth; // 复原宽度

    // 计算数组长度
    let n_bytes = 4; // w
    n_bytes += 4; // h
    n_bytes += 8; // padding
    n_bytes += 8; // cubeSize
    n_bytes += w * h * 4; // depthData
    n_bytes += 8; // width
    n_bytes += 8; // reliefHeight
    n_bytes += 8; // thickness;
    n_bytes += 4; // pillar type
    n_bytes += 16 * 8; // relief matrix
    
    let pillarPosition = currentPillarMesh.geometry.attributes.position;
    let pillarIndices = currentPillarMesh.geometry.index;
    n_bytes += 4; // pillar vertices count
    n_bytes += pillarPosition.count * 3 * 4; // pillar vertices data
    n_bytes += 4; // pillar index count
    if (pillarIndices) {
        n_bytes += pillarIndices.count * 4; // pillar index data
    }
    n_bytes += 16 * 8; // pillar matrix

    // 创建数组和输出器
    let buffer = new ArrayBuffer(n_bytes);
    let writer = new DataView(buffer);

    // 写入浮雕部分数据
    let index = 0;
    writer.setInt32(index, w, true);
    index += 4;
    writer.setInt32(index, h, true);
    index += 4;
    writer.setFloat64(index, padding, true);
    index += 8;
    writer.setFloat64(index, cubeSize, true);
    index += 8;
    for (let i = 0; i < data.data.length; i += 4) {
        let grey = data.data[i] * SourceExporter.RedChannelRatio
            + data.data[i + 1] * SourceExporter.GreenChannelRatio
            + data.data[i + 2] * SourceExporter.BlueChannelRatio;
        writer.setFloat32(index, grey, true);
        index += 4;
    }
    writer.setFloat64(index, draw.width, true);
    index += 8;
    writer.setFloat64(index, draw.height, true);
    index += 8;
    writer.setFloat64(index, draw.thickness, true);
    index += 8;
    writer.setInt32(index, draw.pillar === "type-1" ? 1 : 0, true); // not fill bottom
    index += 4;
    
    currentMesh.updateMatrix();
    for (let i = 0; i < currentMesh.matrix.elements.length; i++) {
        writer.setFloat64(index, currentMesh.matrix.elements[i], true);
        index += 8;
    }

    
    // 写入支撑数据
    writer.setInt32(index, pillarPosition.count, true); // 点的数量
    index += 4;
    for (let i = 0; i < pillarPosition.array.length; i++) {
        writer.setFloat32(index, pillarPosition.array[i], true);
        index += 4;
    }
    writer.setInt32(index, pillarIndices ? pillarIndices.count / 3 : 0, true);
    index += 4;
    if (pillarIndices) {
        for (let i = 0; i < pillarIndices.array.length; i++) {
            writer.setInt32(index, pillarIndices.array[i], true);
            index += 4;
        }
    }
    
    currentPillarMesh.updateMatrix();
    for (let i = 0; i < currentPillarMesh.matrix.elements.length; i++) {
        writer.setFloat64(index, currentPillarMesh.matrix.elements[i], true);
        index += 8;
    }

    return new Blob([buffer], { type: "application/octet-binary" });
}

export {
    SourceExporter
}




// WEBPACK FOOTER //
// ./src/views/reliefOrnaments/scripts/SourceExporter.js